import api from '../../services/api'
import * as types from '../types'

function authorize (username, password, organizationId) {
  return (dispatch) => {
    dispatch(isFetching(types.AUTH_IS_FETCHING, true))

    return api.auth.authorize(username, password, organizationId).then(response => {
      dispatch({
        type: types.AUTH_SUCCESS
      })
      return response
    }).then((response) => {
      dispatch(isFetching(types.AUTH_IS_FETCHING, false))
      return response
    }).catch((response) => {
      dispatch(isFetching(types.AUTH_IS_FETCHING, false))
      throw response
    })
  }
}

function authorizeAdmin (username, password) {
  return (dispatch) => {
    dispatch(isFetching(types.AUTH_IS_FETCHING, true))

    return api.auth.authorizeAdmin(username, password).then(response => {
      dispatch({
        type: types.AUTH_SUCCESS
      })
      return response
    }).then((response) => {
      dispatch(isFetching(types.AUTH_IS_FETCHING, false))
      return response
    }).catch((response) => {
      dispatch(isFetching(types.AUTH_IS_FETCHING, false))
      throw response
    })
  }
}

function authenticate () {
  return (dispatch) => {
    dispatch(isFetching(types.AUTH_IS_FETCHING, true))

    if (api.auth.isAuthenticated()) {
      dispatch({
        type: types.AUTH_SUCCESS
      })
      dispatch(isFetching(types.AUTH_IS_FETCHING, false))
      return true
    } else {
      dispatch({
        type: types.AUTH_FAILED
      })
      setTimeout(() => {
        dispatch(isFetching(types.AUTH_IS_FETCHING, false))
      }, 1000)
      return false
    }
  }
}

function isFetching (type, payload) {
  return {
    type,
    payload
  }
}

export {
  authorize,
  authorizeAdmin,
  authenticate
}



// WEBPACK FOOTER //
// ./src/store/actions/auth.js